import React from "react";
import { Modal } from "../../modal/Modal";

import MovementCore from "./MovementCore";

const MovementModal = (props) => {
    const { open, selectedRegion, testId, onClose, clearAndCloseChatbot } = props;

    return (
        <>
            <Modal isOpen={open} className="movement-modal-wrapper">
                <MovementCore
                    bodyRegionList={selectedRegion}
                    testId={testId}
                    onClose={onClose}
                    clearAndCloseChatbot={clearAndCloseChatbot}
                />
            </Modal>
        </>

    )
};

export default MovementModal;